import React, { Component } from 'react';
import loadScripts from '../../dassets/js/custom';
import { Link } from 'react-router-dom';
import api from '../api';
import { toast } from 'react-toastify';
import store from "../redux/store";

class BoardOfDirectors extends Component {
    constructor(props) {
      super(props);  

    this.state = {
        contents: [],
    }
  }

  componentDidMount() {
    loadScripts();
    this.fetchContents();
  }

  fetchContents() {
    api.get(`/getContents?page=bod`)
    .then(response => {
        const contents = response.data.data;
        contents.sort((a, b) => a.order - b.order)
        this.setState({
            contents: contents
        });
    }).catch(error => {
        let err = store.getState().error;
        if (err) {
            toast.error(err.message);
            this.props.history.push(err.redirectUrl)
        }
        console.log(error)
    });
  }
    render() {
        return (
            <>
                {/* =================================
    Inner Header */}
                <div className="inner-header bg-light">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-sm-6 text-sm-start mb-2 mb-sm-0">
                                <h1 className="breadcrumb-title mb-0">Board Of Directors</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb d-flex justify-content-center justify-content-sm-end ms-auto">
                                    <li className="breadcrumb-item"><Link to={"/"}><i className="fas fa-home me-1"></i>Home</Link></li>
                                    <li className="breadcrumb-item"><span>About</span></li>
                                    <li className="breadcrumb-item"><span>Teams</span></li>
                                    <li className="breadcrumb-item active"><span>Board Of Directors</span></li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {/* =================================
  Inner Header */}


                <section className="space-ptb teams">
                    <div className="container">
                        {this.state.contents.map((content, i) => {
                        return <div key={i} className="border-2 rounded p-4  p-sm-5 mb-5">
                            <div className="row">
                                <div className="col-12">
                                    <h6>{content.title}</h6>
                                    <span>{content.slug}</span>
                                    <div className='mt-4' dangerouslySetInnerHTML={{ __html: content.description }} />
                                </div>
                            </div>
                        </div> })}
                    </div>
                </section>
            </>
        );
    }
}

export default BoardOfDirectors